import router from './router'
import {getToken, getUserInfo} from '@/utils/auth'
import { resetRequestLoading } from '@/utils/axiosBisc'
const whiteList = ['/', '/client', '/admin', '/changePassword', '/forgotPassword', '/activateAccount', '/client/participant', '/oauthCallback', '/loginAccountSpecialGuest', '/404'];    // 不重定向白名单设置

router.beforeEach((to, from, next) => {

    if (to.matched.length === 0) { // 如果路由不匹配任何路由记录，则重定向到404页面
        next({ path: '/404' }); // 或者你可以直接在这里处理，而不是创建一个新的路由记录
    }else {
        if (getToken()) {
            /* has token*/
            next()
        } else {
            if (whiteList.indexOf(to.path) !== -1) {
                next()
            } else {
                if(!getUserInfo()) {
                    if(localStorage.getItem('lastRole')) {
                        let _lastRole = localStorage.getItem('lastRole');
                        if (_lastRole === 'admin' || _lastRole === 'pa' || _lastRole === 'da') {
                            next('/admin');
                        } else if (_lastRole === 'ca') {
                            next('/client');
                        } else if (_lastRole === 'participant') {
                            next('/');
                        } else {
                            next('/');
                        }
                    }else {
                        next('/');
                    }
                    return;
                }
                let _role = getUserInfo().roles[0].roleKey;

                if (_role === 'admin' || _role === 'pa' || _role === 'da') {
                    next('/admin');
                } else if (_role === 'ca') {
                    next('/client');
                } else if (_role === 'participant') {
                    next('/');
                }
            }
        }
    }
});

router.afterEach(() => {
    resetRequestLoading();
});
